import { stage } from 'config/stage';

import { Auth } from '@aws-amplify/auth';

const tenantManagementServiceAPI = {
    prd: {
        endpoint: 'https://uhdg0ahs3d.execute-api.us-west-2.amazonaws.com/dev',
        region: 'us-west-2',
    },
    test: {
        endpoint: 'https://hh3iqenpr2.execute-api.us-west-2.amazonaws.com/dev',
        region: 'us-west-2',
    },
    dev: {
        endpoint: 'https://e4f81ajvp6.execute-api.us-west-2.amazonaws.com/dev',
        region: 'us-west-2',
    },
    cloud9: {
        endpoint: 'https://e4f81ajvp6.execute-api.us-west-2.amazonaws.com/dev',
        region: 'us-west-2',
    },
    ide: {
        endpoint: 'https://e4f81ajvp6.execute-api.us-west-2.amazonaws.com/dev',
        region: 'us-west-2',
        apiKey: 'api-key-cloud9',
    },
};

const getCustomHeader = async () => {
    try {
        const { idToken } = await Auth.currentSession();
        const token = idToken.jwtToken;
        return {
            Authorization: `${token}`,
            'x-api-key': tenantManagementServiceAPI[stage].apiKey,
        };
    } catch (e) {
        return {
            'x-api-key': tenantManagementServiceAPI[stage].apiKey,
        };
    }
};

let API = {
    endpoints: [
        {
            name: 'TenantManagementServiceAPI',
            endpoint: tenantManagementServiceAPI[stage].endpoint,
            region: tenantManagementServiceAPI[stage].region,
            custom_header: getCustomHeader,
        },
    ],
};

export default API;
